// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RunSummaryOut } from './runSummaryOut.zod.ts';

export const AdvisorRunListOut = zod.object({
  "page": zod.int(),
  "page_size": zod.int(),
  "runs": zod.array(RunSummaryOut),
  "total": zod.int()
});

export type AdvisorRunListOut = zod.input<typeof AdvisorRunListOut>;
export type AdvisorRunListOutOutput = zod.output<typeof AdvisorRunListOut>;
